import { Suspense } from 'react';
import { PersonDetailsHeader } from '@features';
import { Loader } from '@mantine/core';
import { PageLayout } from '@pages';
import { Outlet } from '@tanstack/react-router';
import { PersonDetailsTabs } from './components';

export const PersonDetailsPage: React.FC = () => {
  return (
    <PageLayout
      title={
        <Suspense fallback={<Loader size="xs" color="white" />}>
          <PersonDetailsHeader />
        </Suspense>
      }
    >
      <PersonDetailsTabs />
      <Outlet />
    </PageLayout>
  );
};
